import { FEATURE_NAME } from './consts';

export const UPDATE_QUESTION = `${FEATURE_NAME}/UPDATE_QUESTION`;
